// Generated by CoffeeScript 1.12.7
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('views/success',['require','underscore','sp/ui/questions/question_view','sp/utilities/markdown_to_html','sp/utilities/strip_markdown','text!templates/success.html','etc/definitions','tinycolor'],function(require) {
  var QuestionView, SuccessView, _, logo, markdownToHtml, stripMarkdown, successTemplate, tinycolor;
  _ = require('underscore');
  QuestionView = require('sp/ui/questions/question_view');
  markdownToHtml = require('sp/utilities/markdown_to_html');
  stripMarkdown = require('sp/utilities/strip_markdown');
  successTemplate = require('text!templates/success.html');
  logo = require('etc/definitions').logo;
  tinycolor = require('tinycolor');
  return SuccessView = (function(superClass) {
    extend(SuccessView, superClass);

    function SuccessView() {
      this.windowResizeHandler = bind(this.windowResizeHandler, this);
      return SuccessView.__super__.constructor.apply(this, arguments);
    }

    SuccessView.prototype.id = "survey-success";

    SuccessView.prototype.initialize = function(options) {
      SuccessView.__super__.initialize.call(this, options);
      if (!_.isFunction(_.markdownToHtml)) {
        _.mixin({
          markdownToHtml: markdownToHtml
        });
      }
      return this.initListeners();
    };

    SuccessView.prototype.render = function() {
      var data, template;
      data = this.model.toJSON();
      data.definitions = this.definitions;
      setTimeout(function() {
        var bgColor, color;
        if (!data.branding.logo || !data.branding.logo.length) {
          bgColor = $('#success-header').css("background-color");
          color = tinycolor(bgColor);
          if (color.getLuminance() > .5) {
            return $("#success-header img").attr('src', logo.dark);
          } else {
            return $("#success-header img").attr('src', logo.light);
          }
        }
      }, 0);
      if (!data.success) {
        data.success = {};
      }
      template = _.template(successTemplate)(data);
      return this.$el.attr({
        role: 'alert',
        title: 'survey complete'
      }).append(template).hide();
    };

    SuccessView.prototype["in"] = function(callback) {
      var img;
      if (callback == null) {
        callback = function() {};
      }
      if (this.model.get('success') && this.model.get('success').img) {
        img = new Image();
        img.src = this.model.get('success').img;
        return $(img).load((function(_this) {
          return function() {
            return SuccessView.__super__["in"].call(_this, callback);
          };
        })(this)).error((function(_this) {
          return function() {
            _this.$el.find("#success-image").remove();
            return SuccessView.__super__["in"].call(_this, callback);
          };
        })(this));
      } else {
        return SuccessView.__super__["in"].call(this, callback);
      }
    };

    SuccessView.prototype.windowResizeHandler = function(e) {
      return this.center({
        animate: false
      });
    };

    SuccessView.prototype.initListeners = function() {
      return $(window).resize(this.windowResizeHandler);
    };

    return SuccessView;

  })(QuestionView);
});

